<template>
  <div class="footer">
    <div id="mydiv" style="width: 100%; height: 465px">
      <vue-particles id="tsparticles" :options="options" />
    </div>
    <div class="footer_content">
      <div class="footer_content_top clear">
        <div class="content_top_share fl">
          <div>
            <img draggable="false" :src="data.companyIconUrl" />
          </div>
          <div style="width: 170px; margin-top: 20px">
            <img draggable="false" :src="data.qrCodeUrl" style="width: 100%" />
          </div>
        </div>
        <div class="content_top_left fl clear">
          <div class="top_left_list fl">
            <dd>
              <a @click="handleRoute('/about')">关于我们</a>
            </dd>
            <dt>
              <a @click="handleRoute('/about')">公司简介</a>
              <a @click="handleRoute('/about')">企业文化</a>
              <a @click="handleRoute('/about')">资质荣誉</a>
            </dt>
          </div>
          <div class="top_left_list fl">
            <dd>
              <a @click="handleRoute('/service')">服务项目</a>
            </dd>
            <dt>
              <a @click="handleRoute('/service')">一站式服务</a>
              <a @click="handleRoute('/internetThings')">物联网接入</a>
              <a @click="handleRoute('/remoteSensing')">遥感服务</a>
              <a @click="handleRoute('/project')">项目管理</a>
            </dt>
          </div>
          <div class="top_left_list fl">
            <dd>
              <a @click="handleRoute('/contact')">联系我们</a>
            </dd>
            <dt>
              <a @click="handleRoute('/contact')">联系我们</a>
              <a @click="handleRoute('/contact')">人才招聘</a>
            </dt>
          </div>
        </div>
        <div class="content_top_right fr">
          <div class="top_right_title">联系方式</div>
          <div class="top_right_content">
            <div class="right_content_list clear">
              <!-- <dd class="fl iconfont">&#xe62c;</dd> -->
              <dd class="fl iconfont">
                <i class="iconfont icon-zuoji"></i>
              </dd>
              <dt class="fl">电话：{{ data.companyTel }}</dt>
            </div>
            <div class="right_content_list clear">
              <!-- <dd class="fl iconfont">&#xe663;</dd> -->
              <dd class="fl iconfont">
                <i class="iconfont icon-qq"></i>
              </dd>
              <dt class="fl">QQ ：{{ data.contactQq }}</dt>
            </div>
            <div class="right_content_list clear">
              <!-- <dd class="fl iconfont">&#xe624;</dd> -->
              <dd class="fl iconfont">
                <i class="iconfont icon-youxiang"></i>
              </dd>
              <dt class="fl">邮箱：{{ data.contactMailbox }}</dt>
            </div>
            <div class="right_content_list clear">
              <!-- <dd class="fl iconfont">&#xe604;</dd> -->
              <dd class="fl iconfont">
                <i class="iconfont icon-dizhi"></i>
              </dd>
              <dt class="fl">地址：{{ data.companyAddress }}</dt>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_content_copyright clear">
      版权所有：{{ data.companyName }}
      <a href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">{{
        data.copyright
      }}</a>
    </div>
  </div>
</template>
<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { loadFull } from "tsparticles";
import { getPortalBaseInfo } from "@/api/contact";

// vue-particles 配置
const options = reactive({
  fpsLimit: 100,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
      onHover: {
        enable: true,
        mode: "grab",
      },
      resize: true,
    },
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.6,
        size: 10,
      },
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: "#ffffff",
    },
    links: {
      color: "#ffffff",
      distance: 100,
      enable: true,
      opacity: 0.5,
      width: 1,
    },
    collisions: {
      enable: true,
    },
    move: {
      direction: "none",
      enable: true,
      outMode: "bounce",
      random: false,
      speed: 2,
      straight: false,
    },
    fullScreen: {
      enable: false,
    },
    number: {
      density: {
        enable: true,
        value_area: 200,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
    },
    shape: {
      type: "circle",
    },
    size: {
      random: true,
      value: 3,
    },
  },
  detectRetina: true,
  style: {
    width: "100%",
    height: "100%",
    position: "absolute",
  },
});

// 基础信息
const data = reactive({});

// 路由
const router = useRouter();

// 获取基础信息
getPortalBaseInfo({ t: Date.now() }).then((res) => {
  if (res.code === 200) {
    Object.assign(data, res.data);
  }
});

// 路由跳转
function handleRoute(path) {
  router.push(path);
  window.scrollTo(0, 0);
}
</script>
